<div class="container-fluid glb-popup">
  <h2> {{formTitle}} {{analyzedDate | date:'MM/dd/yy EEE'}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <!--<textarea formControlName="logOutput" id="logOutput" [rows]="10" pInputTextarea readonly="true"></textarea>
            <label for="logOutput">Log Output</label>
            <span *ngFor="let validation of validationMessages.logOutput">
              <small class="p-invalid"
                *ngIf="form1.get('logOutput').hasError(validation.type) && (form1.get('logOutput').dirty || form1.get('logOutput').touched)">{{validation.message}}
              </small>
            </span>-->
            <p-table [value]="logOutput" [paginator]="true" [rows]="50" [responsive]="true"
              [sortMode]="'multiple'" stripedRows
              scrollHeight="400px" [autoLayout]="true" [responsive]="true" [scrollable]="true" >
              <ng-template pTemplate="caption">
                <div class="d-block text-start">
                  <h5>Log Output</h5>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="logmanId" style="width:6%">Logman ID
                    <p-sortIcon field="logmanId"></p-sortIcon>
                  </th>
                  <th pSortableColumn="eventName" style="width:10%">Event Name
                    <p-sortIcon field="eventName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="inputValue" style="width:10%">Input Value
                    <p-sortIcon field="inputValue"></p-sortIcon>
                  </th>
                  <th pSortableColumn="inputValueName" style="width:10%">Input Value Name
                    <p-sortIcon field="inputValueName"></p-sortIcon>
                  </th>
                  <th [pSortableColumn]="'changeValue'">Change Value
                    <p-sortIcon [field]="changeValue"></p-sortIcon>
                  </th>
                  <th [pSortableColumn]="'changeAmount'">Change Amount
                    <p-sortIcon [field]="changeAmount"></p-sortIcon>
                  </th>
                  <th pSortableColumn="outputValue" style="width:10%">Output Value
                    <p-sortIcon field="outputValue"></p-sortIcon>
                  </th>
                  <th pSortableColumn="outputValueName" style="width:10%">Output Value Name
                    <p-sortIcon field="outputValueName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="message" style="width:10%">Message
                    <p-sortIcon field="message"></p-sortIcon>
                  </th>
                  <th pSortableColumn="className" style="width:10%">Class Name
                    <p-sortIcon field="className"></p-sortIcon>
                  </th>
                  <th pSortableColumn="methodName" style="width:10%">Method Name
                    <p-sortIcon field="methodName"></p-sortIcon>
                  </th>
                  <th pSortableColumn="referenceId" style="width:10%">Reference Id
                    <p-sortIcon field="referenceId"></p-sortIcon>
                  </th>
                  <th pSortableColumn="severity" style="width:4%">Severity
                    <p-sortIcon field="severity"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-log>
                <tr>
                  <td>{{ log.logmanId }}</td>
                  <td>{{ log.eventName }}</td>
                  <td>{{ log.inputValue | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
                  <td>{{ log.inputValueName }}</td>
                  <td>{{ log.changeValue }}</td>
                  <td>{{ log.changeAmount | currency : 'USD' : 'symbol' : '1.0-0'}} </td>
                <td [ngClass]="{
                    'red-background': log.rateLogSeverity === 'RU',
                    'green-background': log.rateLogSeverity === 'RD',
                    'blue-background': log.rateLogSeverity === 'NA'
                  }">{{ log.outputValue | currency : 'USD' : 'symbol' : '1.0-0'}}</td>
                  <td>{{ log.outputValueName }}</td>
                  <td>{{ log.message }}</td>
                  <td>{{ log.className }}</td>
                  <td>{{ log.methodName }}</td>
                  <td>{{ log.referenceId }}</td>
                  <td>{{ log.severity }}</td>
                </tr>
              </ng-template>
            </p-table>
          </span>
        </div>

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Rate Bucket name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6"></div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>List Price Amount</mat-label>
            <input matInput (blur)="onFieldValueChange('listPriceAMT', 'listPriceAMTExpDate')" formControlName="listPriceAMT">
            @for (validation of validationMessages.listPriceAMT; track validation) {
              <mat-error>
                @if (form1.get('listPriceAMT').hasError(validation.type) && (form1.get('listPriceAMT').dirty || form1.get('listPriceAMT').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>List Price AMT Exp Date</mat-label>
            <input matInput [matDatepicker]="listPriceAMTExpDatePicker" formControlName="listPriceAMTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="listPriceAMTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #listPriceAMTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.listPriceAMTExpDate; track validation) {
              <mat-error>
                @if (form1.get('listPriceAMTExpDate').hasError(validation.type) && (form1.get('listPriceAMTExpDate').dirty || form1.get('listPriceAMTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('listPriceAMTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('listPriceAMTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('listPriceAMTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('listPriceAMTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Yield Price Amount</mat-label>
            <input matInput (blur)="onFieldValueChange('yieldPriceAMT', 'yieldPriceAMTExpDate')" formControlName="yieldPriceAMT">
            @for (validation of validationMessages.yieldPriceAMT; track validation) {
              <mat-error>
                @if (form1.get('yieldPriceAMT').hasError(validation.type) && (form1.get('yieldPriceAMT').dirty || form1.get('yieldPriceAMT').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Yield Price AMT Exp Date</mat-label>
            <input matInput [matDatepicker]="yieldPriceAMTExpDatePicker" formControlName="yieldPriceAMTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="yieldPriceAMTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #yieldPriceAMTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.yieldPriceAMTExpDate; track validation) {
              <mat-error>
                @if (form1.get('yieldPriceAMTExpDate').hasError(validation.type) && (form1.get('yieldPriceAMTExpDate').dirty || form1.get('yieldPriceAMTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('yieldPriceAMTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('yieldPriceAMTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('yieldPriceAMTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('yieldPriceAMTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>List Price Adjust AMT</mat-label>
            <input matInput (blur)="onFieldValueChange('listPriceAdjustAMT', 'listPriceAdjustAMTExpDate')" formControlName="listPriceAdjustAMT">
            @for (validation of validationMessages.listPriceAdjustAMT; track validation) {
              <mat-error>
                @if (form1.get('listPriceAdjustAMT').hasError(validation.type) && (form1.get('listPriceAdjustAMT').dirty || form1.get('listPriceAdjustAMT').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>List Price Adjust AMT Exp Date</mat-label>
            <input matInput [matDatepicker]="listPriceAdjustAMTExpDatePicker" formControlName="listPriceAdjustAMTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="listPriceAdjustAMTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #listPriceAdjustAMTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.listPriceAdjustAMTExpDate; track validation) {
              <mat-error>
                @if (form1.get('listPriceAdjustAMTExpDate').hasError(validation.type) && (form1.get('listPriceAdjustAMTExpDate').dirty || form1.get('listPriceAdjustAMTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('listPriceAdjustAMTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('listPriceAdjustAMTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('listPriceAdjustAMTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('listPriceAdjustAMTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>List Price Adjust PCT: <b>{{listPriceAdjustPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('listPriceAdjustPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #listPriceAdjustPCT (change)="onFieldValueChange('listPriceAdjustPCT', 'listPriceAdjustPCTExpDate')" formControlName="listPriceAdjustPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('listPriceAdjustPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>List Price Adjust PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="listPriceAdjustPCTExpDatePicker" formControlName="listPriceAdjustPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="listPriceAdjustPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #listPriceAdjustPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.listPriceAdjustPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('listPriceAdjustPCTExpDate').hasError(validation.type) && (form1.get('listPriceAdjustPCTExpDate').dirty || form1.get('listPriceAdjustPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('listPriceAdjustPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('listPriceAdjustPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('listPriceAdjustPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('listPriceAdjustPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        @if (isMonday) {
          <div class="col-lg-6">
            <div class="w-100">
              <mat-label>Monday Adjust PCT: <b>{{mondayAdjPCT.value*100}}%</b></mat-label>
              <div>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreaseWeekDayPercentage('mondayAdjPCT', 'mondayAdjPCTExpDate')">
                  <i class="pi pi-minus"></i>
                </button>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                  pTooltip="Range: -1 to +1 as decimal."
                  tooltipPosition="bottom">
                  <input matSliderThumb #mondayAdjPCT (change)="onFieldValueChange('mondayAdjPCT', 'mondayAdjPCTExpDate')" formControlName="mondayAdjPCT">
                </mat-slider>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increaseWeekDayPercentage('mondayAdjPCT', 'mondayAdjPCTExpDate')">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
            </div>
          </div>
        }
        @if (isMonday) {
          <div class="col-lg-6">
            <mat-form-field class="w-100">
              <mat-label>Monday Adjust PCT Exp Date</mat-label>
              <input matInput [matDatepicker]="mondayAdjPCTExpDatePicker" formControlName="mondayAdjPCTExpDate">
              <mat-datepicker-toggle matIconSuffix [for]="mondayAdjPCTExpDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #mondayAdjPCTExpDatePicker></mat-datepicker>
              @for (validation of validationMessages.mondayAdjPCTExpDate; track validation) {
                <mat-error>
                  @if (form1.get('mondayAdjPCTExpDate').hasError(validation.type) && (form1.get('mondayAdjPCTExpDate').dirty || form1.get('mondayAdjPCTExpDate').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
              <a (click)="updateExpDate('mondayAdjPCTExpDate', 7)">7</a>&nbsp;
              <a (click)="updateExpDate('mondayAdjPCTExpDate', 14)">14</a>&nbsp;
              <a (click)="updateExpDate('mondayAdjPCTExpDate', 21)">21</a>&nbsp;
              <a (click)="updateExpDate('mondayAdjPCTExpDate', 'N')">N</a>
            </mat-form-field>
          </div>
        }

        @if (isTuesday) {
          <div class="col-lg-6">
            <div class="w-100">
              <mat-label>Tuesday Adjust PCT: <b>{{tuesdayAdjPCT.value*100}}%</b></mat-label>
              <div>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreaseWeekDayPercentage('tuesdayAdjPCT', 'tuesdayAdjPCTExpDate')">
                  <i class="pi pi-minus"></i>
                </button>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                  pTooltip="Range: -1 to +1 as decimal."
                  tooltipPosition="bottom">
                  <input matSliderThumb #tuesdayAdjPCT (change)="onFieldValueChange('tuesdayAdjPCT', 'tuesdayAdjPCTExpDate')" formControlName="tuesdayAdjPCT">
                </mat-slider>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increaseWeekDayPercentage('tuesdayAdjPCT', 'tuesdayAdjPCTExpDate')">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
            </div>
          </div>
        }
        @if (isTuesday) {
          <div class="col-lg-6">
            <mat-form-field class="w-100">
              <mat-label>Tuesday Adjust PCT Exp Date</mat-label>
              <input matInput [matDatepicker]="tuesdayAdjPCTExpDatePicker" formControlName="tuesdayAdjPCTExpDate">
              <mat-datepicker-toggle matIconSuffix [for]="tuesdayAdjPCTExpDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #tuesdayAdjPCTExpDatePicker></mat-datepicker>
              @for (validation of validationMessages.tuesdayAdjPCTExpDate; track validation) {
                <mat-error>
                  @if (form1.get('tuesdayAdjPCTExpDate').hasError(validation.type) && (form1.get('tuesdayAdjPCTExpDate').dirty || form1.get('tuesdayAdjPCTExpDate').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
              <a (click)="updateExpDate('tuesdayAdjPCTExpDate', 7)">7</a>&nbsp;
              <a (click)="updateExpDate('tuesdayAdjPCTExpDate', 14)">14</a>&nbsp;
              <a (click)="updateExpDate('tuesdayAdjPCTExpDate', 21)">21</a>&nbsp;
              <a (click)="updateExpDate('tuesdayAdjPCTExpDate', 'N')">N</a>
            </mat-form-field>
          </div>
        }

        @if (isWednesday) {
          <div class="col-lg-6">
            <div class="w-100">
              <mat-label>Wednesday Adjust PCT: <b>{{wednesdayAdjPCT.value*100}}%</b></mat-label>
              <div>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreaseWeekDayPercentage('wednesdayAdjPCT', 'wednesdayAdjPCTExpDate')">
                  <i class="pi pi-minus"></i>
                </button>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                  pTooltip="Range: -1 to +1 as decimal."
                  tooltipPosition="bottom">
                  <input matSliderThumb #wednesdayAdjPCT (change)="onFieldValueChange('wednesdayAdjPCT', 'wednesdayAdjPCTExpDate')" formControlName="wednesdayAdjPCT">
                </mat-slider>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increaseWeekDayPercentage('wednesdayAdjPCT', 'wednesdayAdjPCTExpDate')">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
            </div>
          </div>
        }
        @if (isWednesday) {
          <div class="col-lg-6">
            <mat-form-field class="w-100">
              <mat-label>Wednesday Adjust PCT Exp Date</mat-label>
              <input matInput [matDatepicker]="wednesdayAdjPCTExpDatePicker" formControlName="wednesdayAdjPCTExpDate">
              <mat-datepicker-toggle matIconSuffix [for]="wednesdayAdjPCTExpDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #wednesdayAdjPCTExpDatePicker></mat-datepicker>
              @for (validation of validationMessages.wednesdayAdjPCTExpDate; track validation) {
                <mat-error>
                  @if (form1.get('wednesdayAdjPCTExpDate').hasError(validation.type) && (form1.get('wednesdayAdjPCTExpDate').dirty || form1.get('wednesdayAdjPCTExpDate').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
              <a (click)="updateExpDate('wednesdayAdjPCTExpDate', 7)">7</a>&nbsp;
              <a (click)="updateExpDate('wednesdayAdjPCTExpDate', 14)">14</a>&nbsp;
              <a (click)="updateExpDate('wednesdayAdjPCTExpDate', 21)">21</a>&nbsp;
              <a (click)="updateExpDate('wednesdayAdjPCTExpDate', 'N')">N</a>
            </mat-form-field>
          </div>
        }

        @if (isThursday) {
          <div class="col-lg-6">
            <div class="w-100">
              <mat-label>Thursday Adjust PCT: <b>{{thursdayAdjPCT.value*100}}%</b></mat-label>
              <div>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreaseWeekDayPercentage('thursdayAdjPCT', 'thursdayAdjPCTExpDate')">
                  <i class="pi pi-minus"></i>
                </button>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                  pTooltip="Range: -1 to +1 as decimal."
                  tooltipPosition="bottom">
                  <input matSliderThumb #thursdayAdjPCT (change)="onFieldValueChange('thursdayAdjPCT', 'thursdayAdjPCTExpDate')" formControlName="thursdayAdjPCT">
                </mat-slider>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increaseWeekDayPercentage('thursdayAdjPCT', 'thursdayAdjPCTExpDate')">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
            </div>
          </div>
        }
        @if (isThursday) {
          <div class="col-lg-6">
            <mat-form-field class="w-100">
              <mat-label>Thursday Adjust PCT Exp Date</mat-label>
              <input matInput [matDatepicker]="thursdayAdjPCTExpDatePicker" formControlName="thursdayAdjPCTExpDate">
              <mat-datepicker-toggle matIconSuffix [for]="thursdayAdjPCTExpDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #thursdayAdjPCTExpDatePicker></mat-datepicker>
              @for (validation of validationMessages.thursdayAdjPCTExpDate; track validation) {
                <mat-error>
                  @if (form1.get('thursdayAdjPCTExpDate').hasError(validation.type) && (form1.get('thursdayAdjPCTExpDate').dirty || form1.get('thursdayAdjPCTExpDate').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
              <a (click)="updateExpDate('thursdayAdjPCTExpDate', 7)">7</a>&nbsp;
              <a (click)="updateExpDate('thursdayAdjPCTExpDate', 14)">14</a>&nbsp;
              <a (click)="updateExpDate('thursdayAdjPCTExpDate', 21)">21</a>&nbsp;
              <a (click)="updateExpDate('thursdayAdjPCTExpDate', 'N')">N</a>
            </mat-form-field>
          </div>
        }

        @if (isFriday) {
          <div class="col-lg-6">
            <div class="w-100">
              <mat-label>Friday Adjust PCT: <b>{{fridayAdjPCT.value*100}}%</b></mat-label>
              <div>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreaseWeekDayPercentage('fridayAdjPCT', 'fridayAdjPCTExpDate')">
                  <i class="pi pi-minus"></i>
                </button>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                  pTooltip="Range: -1 to +1 as decimal."
                  tooltipPosition="bottom">
                  <input matSliderThumb #fridayAdjPCT (change)="onFieldValueChange('fridayAdjPCT', 'fridayAdjPCTExpDate')" formControlName="fridayAdjPCT">
                </mat-slider>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increaseWeekDayPercentage('fridayAdjPCT', 'fridayAdjPCTExpDate')">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
            </div>
          </div>
        }
        @if (isFriday) {
          <div class="col-lg-6">
            <mat-form-field class="w-100">
              <mat-label>Friday Adjust PCT Exp Date</mat-label>
              <input matInput [matDatepicker]="fridayAdjPCTExpDatePicker" formControlName="fridayAdjPCTExpDate">
              <mat-datepicker-toggle matIconSuffix [for]="fridayAdjPCTExpDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #fridayAdjPCTExpDatePicker></mat-datepicker>
              @for (validation of validationMessages.fridayAdjPCTExpDate; track validation) {
                <mat-error>
                  @if (form1.get('fridayAdjPCTExpDate').hasError(validation.type) && (form1.get('fridayAdjPCTExpDate').dirty || form1.get('fridayAdjPCTExpDate').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
              <a (click)="updateExpDate('fridayAdjPCTExpDate', 7)">7</a>&nbsp;
              <a (click)="updateExpDate('fridayAdjPCTExpDate', 14)">14</a>&nbsp;
              <a (click)="updateExpDate('fridayAdjPCTExpDate', 21)">21</a>&nbsp;
              <a (click)="updateExpDate('fridayAdjPCTExpDate', 'N')">N</a>
            </mat-form-field>
          </div>
        }

        @if (isSaturday) {
          <div class="col-lg-6">
            <div class="w-100">
              <mat-label>Saturday Adjust PCT: <b>{{saturdayAdjPCT.value*100}}%</b></mat-label>
              <div>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreaseWeekDayPercentage('saturdayAdjPCT', 'saturdayAdjPCTExpDate')">
                  <i class="pi pi-minus"></i>
                </button>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                  pTooltip="Range: -1 to +1 as decimal."
                  tooltipPosition="bottom">
                  <input matSliderThumb #saturdayAdjPCT (change)="onFieldValueChange('saturdayAdjPCT', 'saturdayAdjPCTExpDate')" formControlName="saturdayAdjPCT">
                </mat-slider>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increaseWeekDayPercentage('saturdayAdjPCT', 'saturdayAdjPCTExpDate')">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
            </div>
          </div>
        }
        @if (isSaturday) {
          <div class="col-lg-6">
            <mat-form-field class="w-100">
              <mat-label>Saturday Adjust PCT Exp Date</mat-label>
              <input matInput [matDatepicker]="saturdayAdjPCTExpDatePicker" formControlName="saturdayAdjPCTExpDate">
              <mat-datepicker-toggle matIconSuffix [for]="saturdayAdjPCTExpDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #saturdayAdjPCTExpDatePicker></mat-datepicker>
              @for (validation of validationMessages.saturdayAdjPCTExpDate; track validation) {
                <mat-error>
                  @if (form1.get('saturdayAdjPCTExpDate').hasError(validation.type) && (form1.get('saturdayAdjPCTExpDate').dirty || form1.get('saturdayAdjPCTExpDate').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
              <a (click)="updateExpDate('saturdayAdjPCTExpDate', 7)">7</a>&nbsp;
              <a (click)="updateExpDate('saturdayAdjPCTExpDate', 14)">14</a>&nbsp;
              <a (click)="updateExpDate('saturdayAdjPCTExpDate', 21)">21</a>&nbsp;
              <a (click)="updateExpDate('saturdayAdjPCTExpDate', 'N')">N</a>
            </mat-form-field>
          </div>
        }

        @if (isSunday) {
          <div class="col-lg-6">
            <div class="w-100">
              <mat-label>Sunday Adjust PCT: <b>{{sundayAdjPCT.value*100}}%</b></mat-label>
              <div>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreaseWeekDayPercentage('sundayAdjPCT', 'sundayAdjPCTExpDate')">
                  <i class="pi pi-minus"></i>
                </button>
                <mat-slider class="flex-1" min="-1" max="1" step=".01"
                  pTooltip="Range: -1 to +1 as decimal."
                  tooltipPosition="bottom">
                  <input matSliderThumb #sundayAdjPCT (change)="onFieldValueChange('sundayAdjPCT', 'sundayAdjPCTExpDate')" formControlName="sundayAdjPCT">
                </mat-slider>
                <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increaseWeekDayPercentage('sundayAdjPCT', 'sundayAdjPCTExpDate')">
                  <i class="pi pi-plus"></i>
                </button>
              </div>
            </div>
          </div>
        }
        @if (isSunday) {
          <div class="col-lg-6">
            <mat-form-field class="w-100">
              <mat-label>Sunday Adjust PCT Exp Date</mat-label>
              <input matInput [matDatepicker]="sundayAdjPCTExpDatePicker" formControlName="sundayAdjPCTExpDate">
              <mat-datepicker-toggle matIconSuffix [for]="sundayAdjPCTExpDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #sundayAdjPCTExpDatePicker></mat-datepicker>
              @for (validation of validationMessages.sundayAdjPCTExpDate; track validation) {
                <mat-error>
                  @if (form1.get('sundayAdjPCTExpDate').hasError(validation.type) && (form1.get('sundayAdjPCTExpDate').dirty || form1.get('sundayAdjPCTExpDate').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
              <a (click)="updateExpDate('sundayAdjPCTExpDate', 7)">7</a>&nbsp;
              <a (click)="updateExpDate('sundayAdjPCTExpDate', 14)">14</a>&nbsp;
              <a (click)="updateExpDate('sundayAdjPCTExpDate', 21)">21</a>&nbsp;
              <a (click)="updateExpDate('sundayAdjPCTExpDate', 'N')">N</a>
            </mat-form-field>
          </div>
        }

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Floor Rate Manager AMT</mat-label>
            <input matInput (blur)="onFieldValueChange('floorRateManagerAMT', 'floorRateManagerAMTExpDate')" formControlName="floorRateManagerAMT">
            @for (validation of validationMessages.floorRateManagerAMT; track validation) {
              <mat-error>
                @if (form1.get('floorRateManagerAMT').hasError(validation.type) && (form1.get('floorRateManagerAMT').dirty || form1.get('floorRateManagerAMT').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Floor Rate Manager AMT Exp Date</mat-label>
            <input matInput [matDatepicker]="floorRateManagerAMTExpDatePicker" formControlName="floorRateManagerAMTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="floorRateManagerAMTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #floorRateManagerAMTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.floorRateManagerAMTExpDate; track validation) {
              <mat-error>
                @if (form1.get('floorRateManagerAMTExpDate').hasError(validation.type) && (form1.get('floorRateManagerAMTExpDate').dirty || form1.get('floorRateManagerAMTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('floorRateManagerAMTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('floorRateManagerAMTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('floorRateManagerAMTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('floorRateManagerAMTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Floor Rate Owner AMT</mat-label>
            <input matInput (blur)="onFieldValueChange('floorRateOwnerAMT', 'floorRateOwnerAMTExpDate')" formControlName="floorRateOwnerAMT">
            @for (validation of validationMessages.floorRateOwnerAMT; track validation) {
              <mat-error>
                @if (form1.get('floorRateOwnerAMT').hasError(validation.type) && (form1.get('floorRateOwnerAMT').dirty || form1.get('floorRateOwnerAMT').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Floor Rate Owner AMT Exp Date</mat-label>
            <input matInput [matDatepicker]="floorRateOwnerAMTExpDatePicker" formControlName="floorRateOwnerAMTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="floorRateOwnerAMTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #floorRateOwnerAMTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.floorRateOwnerAMTExpDate; track validation) {
              <mat-error>
                @if (form1.get('floorRateOwnerAMTExpDate').hasError(validation.type) && (form1.get('floorRateOwnerAMTExpDate').dirty || form1.get('floorRateOwnerAMTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('floorRateOwnerAMTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('floorRateOwnerAMTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('floorRateOwnerAMTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('floorRateOwnerAMTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Ceiling Rate Manager AMT</mat-label>
            <input matInput (blur)="onFieldValueChange('ceilingRateManagerAMT', 'ceilingRateManagerAMTExpDate')" formControlName="ceilingRateManagerAMT">
            @for (validation of validationMessages.ceilingRateManagerAMT; track validation) {
              <mat-error>
                @if (form1.get('ceilingRateManagerAMT').hasError(validation.type) && (form1.get('ceilingRateManagerAMT').dirty || form1.get('ceilingRateManagerAMT').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Ceiling Rate Manager AMT Exp Date</mat-label>
            <input matInput [matDatepicker]="ceilingRateManagerAMTExpDatePicker" formControlName="ceilingRateManagerAMTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="ceilingRateManagerAMTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #ceilingRateManagerAMTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.ceilingRateManagerAMTExpDate; track validation) {
              <mat-error>
                @if (form1.get('ceilingRateManagerAMTExpDate').hasError(validation.type) && (form1.get('ceilingRateManagerAMTExpDate').dirty || form1.get('ceilingRateManagerAMTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('ceilingRateManagerAMTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('ceilingRateManagerAMTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('ceilingRateManagerAMTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('ceilingRateManagerAMTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Ceiling Rate Owner AMT</mat-label>
            <input matInput (blur)="onFieldValueChange('ceilingRateOwnerAMT', 'ceilingRateOwnerAMTExpDate')" formControlName="ceilingRateOwnerAMT">
            @for (validation of validationMessages.ceilingRateOwnerAMT; track validation) {
              <mat-error>
                @if (form1.get('ceilingRateOwnerAMT').hasError(validation.type) && (form1.get('ceilingRateOwnerAMT').dirty || form1.get('ceilingRateOwnerAMT').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Ceiling Rate Owner AMT Exp Date</mat-label>
            <input matInput [matDatepicker]="ceilingRateOwnerAMTExpDatePicker" formControlName="ceilingRateOwnerAMTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="ceilingRateOwnerAMTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #ceilingRateOwnerAMTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.ceilingRateOwnerAMTExpDate; track validation) {
              <mat-error>
                @if (form1.get('ceilingRateOwnerAMTExpDate').hasError(validation.type) && (form1.get('ceilingRateOwnerAMTExpDate').dirty || form1.get('ceilingRateOwnerAMTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('ceilingRateOwnerAMTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('ceilingRateOwnerAMTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('ceilingRateOwnerAMTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('ceilingRateOwnerAMTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>Expected Occupancy PCT: <b>{{expectedOccupancyPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('expectedOccupancyPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #expectedOccupancyPCT (change)="onFieldValueChange('expectedOccupancyPCT', 'expectedOccupancyPCTExpDate')" formControlName="expectedOccupancyPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('expectedOccupancyPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Expected Occupancy PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="expectedOccupancyPCTExpDatePicker" formControlName="expectedOccupancyPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="expectedOccupancyPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #expectedOccupancyPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.expectedOccupancyPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('expectedOccupancyPCTExpDate').hasError(validation.type) && (form1.get('expectedOccupancyPCTExpDate').dirty || form1.get('expectedOccupancyPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('expectedOccupancyPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('expectedOccupancyPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('expectedOccupancyPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('expectedOccupancyPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>Max Discount PCT: <b>{{maxDiscountPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('maxDiscountPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #maxDiscountPCT (change)="onFieldValueChange('maxDiscountPCT', 'maxDiscountPCTExpDate')" formControlName="maxDiscountPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('maxDiscountPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Max Discount PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="maxDiscountPCTExpDatePicker" formControlName="maxDiscountPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="maxDiscountPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #maxDiscountPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.maxDiscountPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('maxDiscountPCTExpDate').hasError(validation.type) && (form1.get('maxDiscountPCTExpDate').dirty || form1.get('maxDiscountPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('maxDiscountPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('maxDiscountPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('maxDiscountPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('maxDiscountPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Discount Look Forward Days</mat-label>
            <input matInput (blur)="onFieldValueChange('discountLookForwardDays', 'discountLookForwardDaysExpDate')" formControlName="discountLookForwardDays">
            @for (validation of validationMessages.discountLookForwardDays; track validation) {
              <mat-error>
                @if (form1.get('discountLookForwardDays').hasError(validation.type) && (form1.get('discountLookForwardDays').dirty || form1.get('discountLookForwardDays').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Discount Look Forward Days Exp Date</mat-label>
            <input matInput [matDatepicker]="discountLookForwardDaysExpDatePicker" formControlName="discountLookForwardDaysExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="discountLookForwardDaysExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #discountLookForwardDaysExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.discountLookForwardDaysExpDate; track validation) {
              <mat-error>
                @if (form1.get('discountLookForwardDaysExpDate').hasError(validation.type) && (form1.get('discountLookForwardDaysExpDate').dirty || form1.get('discountLookForwardDaysExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('discountLookForwardDaysExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('discountLookForwardDaysExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('discountLookForwardDaysExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('discountLookForwardDaysExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Discount Look Forward Headline Days</mat-label>
            <input matInput (blur)="onFieldValueChange('discountLookForwardHeadlineDays', 'discountLookForwardHeadlineDaysExpDate')" formControlName="discountLookForwardHeadlineDays">
            @for (validation of validationMessages.discountLookForwardHeadlineDays; track validation) {
              <mat-error>
                @if (form1.get('discountLookForwardHeadlineDays').hasError(validation.type) && (form1.get('discountLookForwardHeadlineDays').dirty || form1.get('discountLookForwardHeadlineDays').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Discount Look Forward Headline Days Exp Date</mat-label>
            <input matInput [matDatepicker]="discountLookForwardHeadlineDaysExpDatePicker" formControlName="discountLookForwardHeadlineDaysExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="discountLookForwardHeadlineDaysExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #discountLookForwardHeadlineDaysExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.discountLookForwardHeadlineDaysExpDate; track validation) {
              <mat-error>
                @if (form1.get('discountLookForwardHeadlineDaysExpDate').hasError(validation.type) && (form1.get('discountLookForwardHeadlineDaysExpDate').dirty || form1.get('discountLookForwardHeadlineDaysExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('discountLookForwardHeadlineDaysExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('discountLookForwardHeadlineDaysExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('discountLookForwardHeadlineDaysExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('discountLookForwardHeadlineDaysExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Discount Look Forward Headline Min Nights Days</mat-label>
            <input matInput (blur)="onFieldValueChange('discountLookForwardHeadlineMinNightsDays', 'discountLookForwardHeadlineMinNightsDaysExpDate')" formControlName="discountLookForwardHeadlineMinNightsDays">
            @for (validation of validationMessages.discountLookForwardHeadlineMinNightsDays; track validation) {
              <mat-error>
                @if (form1.get('discountLookForwardHeadlineMinNightsDays').hasError(validation.type) && (form1.get('discountLookForwardHeadlineMinNightsDays').dirty || form1.get('discountLookForwardHeadlineMinNightsDays').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Discount Look Forward Headline Min Nights Days Exp Date</mat-label>
            <input matInput [matDatepicker]="discountLookForwardHeadlineMinNightsDaysExpDatePicker" formControlName="discountLookForwardHeadlineMinNightsDaysExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="discountLookForwardHeadlineMinNightsDaysExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #discountLookForwardHeadlineMinNightsDaysExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.discountLookForwardHeadlineMinNightsDaysExpDate; track validation) {
              <mat-error>
                @if (form1.get('discountLookForwardHeadlineMinNightsDaysExpDate').hasError(validation.type) && (form1.get('discountLookForwardHeadlineMinNightsDaysExpDate').dirty || form1.get('discountLookForwardHeadlineMinNightsDaysExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('discountLookForwardHeadlineMinNightsDaysExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('discountLookForwardHeadlineMinNightsDaysExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('discountLookForwardHeadlineMinNightsDaysExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('discountLookForwardHeadlineMinNightsDaysExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Min Stay Expected NTS</mat-label>
            <input matInput (blur)="onFieldValueChange('minStayExpectedNTS', 'minStayExpectedNTSExpDate')" formControlName="minStayExpectedNTS">
            @for (validation of validationMessages.minStayExpectedNTS; track validation) {
              <mat-error>
                @if (form1.get('minStayExpectedNTS').hasError(validation.type) && (form1.get('minStayExpectedNTS').dirty || form1.get('minStayExpectedNTS').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Min Stay Expected NTS Exp Date</mat-label>
            <input matInput [matDatepicker]="minStayExpectedNTSExpDatePicker" formControlName="minStayExpectedNTSExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="minStayExpectedNTSExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #minStayExpectedNTSExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.minStayExpectedNTSExpDate; track validation) {
              <mat-error>
                @if (form1.get('minStayExpectedNTSExpDate').hasError(validation.type) && (form1.get('minStayExpectedNTSExpDate').dirty || form1.get('minStayExpectedNTSExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('minStayExpectedNTSExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('minStayExpectedNTSExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('minStayExpectedNTSExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('minStayExpectedNTSExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Max Stay Expected NTS</mat-label>
            <input matInput (blur)="onFieldValueChange('maxStayExpectedNTS', 'maxStayExpectedNTSExpDate')" formControlName="maxStayExpectedNTS">
            @for (validation of validationMessages.maxStayExpectedNTS; track validation) {
              <mat-error>
                @if (form1.get('maxStayExpectedNTS').hasError(validation.type) && (form1.get('maxStayExpectedNTS').dirty || form1.get('maxStayExpectedNTS').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Max Stay Expected NTS Exp Date</mat-label>
            <input matInput [matDatepicker]="maxStayExpectedNTSExpDatePicker" formControlName="maxStayExpectedNTSExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="maxStayExpectedNTSExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #maxStayExpectedNTSExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.maxStayExpectedNTSExpDate; track validation) {
              <mat-error>
                @if (form1.get('maxStayExpectedNTSExpDate').hasError(validation.type) && (form1.get('maxStayExpectedNTSExpDate').dirty || form1.get('maxStayExpectedNTSExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('maxStayExpectedNTSExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('maxStayExpectedNTSExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('maxStayExpectedNTSExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('maxStayExpectedNTSExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Avg Stay By Season NTS</mat-label>
            <input matInput (blur)="onFieldValueChange('avgStayBySeasonNTS', 'avgStayBySeasonNTSExpDate')" formControlName="avgStayBySeasonNTS">
            @for (validation of validationMessages.avgStayBySeasonNTS; track validation) {
              <mat-error>
                @if (form1.get('avgStayBySeasonNTS').hasError(validation.type) && (form1.get('avgStayBySeasonNTS').dirty || form1.get('avgStayBySeasonNTS').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Avg Stay By Season NTS Exp Date</mat-label>
            <input matInput [matDatepicker]="avgStayBySeasonNTSExpDatePicker" formControlName="avgStayBySeasonNTSExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="avgStayBySeasonNTSExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #avgStayBySeasonNTSExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.avgStayBySeasonNTSExpDate; track validation) {
              <mat-error>
                @if (form1.get('avgStayBySeasonNTSExpDate').hasError(validation.type) && (form1.get('avgStayBySeasonNTSExpDate').dirty || form1.get('avgStayBySeasonNTSExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('avgStayBySeasonNTSExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('avgStayBySeasonNTSExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('avgStayBySeasonNTSExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('avgStayBySeasonNTSExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>ShortTerm Gap Multiplier PCT: <b>{{shortTermGapMultiplierPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapMultiplierPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #shortTermGapMultiplierPCT (change)="onFieldValueChange('shortTermGapMultiplierPCT', 'shortTermGapMultiplierPCTExpDate')" formControlName="shortTermGapMultiplierPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapMultiplierPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>ShortTerm Gap Multiplier PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="shortTermGapMultiplierPCTExpDatePicker" formControlName="shortTermGapMultiplierPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="shortTermGapMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #shortTermGapMultiplierPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.shortTermGapMultiplierPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('shortTermGapMultiplierPCTExpDate').hasError(validation.type) && (form1.get('shortTermGapMultiplierPCTExpDate').dirty || form1.get('shortTermGapMultiplierPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('shortTermGapMultiplierPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('shortTermGapMultiplierPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('shortTermGapMultiplierPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('shortTermGapMultiplierPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>ShortTerm Gap Penalty PCT: <b>{{shortTermGapPenaltyPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('shortTermGapPenaltyPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #shortTermGapPenaltyPCT (change)="onFieldValueChange('shortTermGapPenaltyPCT', 'shortTermGapPenaltyPCTExpDate')" formControlName="shortTermGapPenaltyPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('shortTermGapPenaltyPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>ShortTerm Gap Penalty PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="shortTermGapPenaltyPCTExpDatePicker" formControlName="shortTermGapPenaltyPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="shortTermGapPenaltyPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #shortTermGapPenaltyPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.shortTermGapPenaltyPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('shortTermGapPenaltyPCTExpDate').hasError(validation.type) && (form1.get('shortTermGapPenaltyPCTExpDate').dirty || form1.get('shortTermGapPenaltyPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('shortTermGapPenaltyPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('shortTermGapPenaltyPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('shortTermGapPenaltyPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('shortTermGapPenaltyPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>ShortTerm Gap Min NumNights Rev AMT</mat-label>
            <input matInput (blur)="onFieldValueChange('shortTermGapMinNumNightsRevNTS', 'shortTermGapMinNumNightsRevNTSExpDate')" formControlName="shortTermGapMinNumNightsRevNTS">
            @for (validation of validationMessages.shortTermGapMinNumNightsRevNTS; track validation) {
              <mat-error>
                @if (form1.get('shortTermGapMinNumNightsRevNTS').hasError(validation.type) && (form1.get('shortTermGapMinNumNightsRevNTS').dirty || form1.get('shortTermGapMinNumNightsRevNTS').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>ShortTerm Gap Min NumNights Rev AMT Exp Date</mat-label>
            <input matInput [matDatepicker]="shortTermGapMinNumNightsRevNTSExpDatePicker" formControlName="shortTermGapMinNumNightsRevNTSExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="shortTermGapMinNumNightsRevNTSExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #shortTermGapMinNumNightsRevNTSExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.shortTermGapMinNumNightsRevNTSExpDate; track validation) {
              <mat-error>
                @if (form1.get('shortTermGapMinNumNightsRevNTSExpDate').hasError(validation.type) && (form1.get('shortTermGapMinNumNightsRevNTSExpDate').dirty || form1.get('shortTermGapMinNumNightsRevNTSExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('shortTermGapMinNumNightsRevNTSExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('shortTermGapMinNumNightsRevNTSExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('shortTermGapMinNumNightsRevNTSExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('shortTermGapMinNumNightsRevNTSExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>Long Term Gap Multiplier PCT: <b>{{longTermGapMultiplierPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapMultiplierPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #longTermGapMultiplierPCT (change)="onFieldValueChange('longTermGapMultiplierPCT', 'longTermGapMultiplierPCTExpDate')" formControlName="longTermGapMultiplierPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapMultiplierPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Long Term Gap Multiplier PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="longTermGapMultiplierPCTExpDatePicker" formControlName="longTermGapMultiplierPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="longTermGapMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #longTermGapMultiplierPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.longTermGapMultiplierPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('longTermGapMultiplierPCTExpDate').hasError(validation.type) && (form1.get('longTermGapMultiplierPCTExpDate').dirty || form1.get('longTermGapMultiplierPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('longTermGapMultiplierPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('longTermGapMultiplierPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('longTermGapMultiplierPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('longTermGapMultiplierPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>Long Term Gap Penalty PCT: <b>{{longTermGapPenaltyPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapPenaltyPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #longTermGapPenaltyPCT (change)="onFieldValueChange('longTermGapPenaltyPCT', 'longTermGapPenaltyPCTExpDate')" formControlName="longTermGapPenaltyPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapPenaltyPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Long Term Gap Penalty PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="longTermGapPenaltyPCTExpDatePicker" formControlName="longTermGapPenaltyPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="longTermGapPenaltyPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #longTermGapPenaltyPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.longTermGapPenaltyPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('longTermGapPenaltyPCTExpDate').hasError(validation.type) && (form1.get('longTermGapPenaltyPCTExpDate').dirty || form1.get('longTermGapPenaltyPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('longTermGapPenaltyPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('longTermGapPenaltyPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('longTermGapPenaltyPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('longTermGapPenaltyPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>Long Term Gap Empty Multiplier PCT: <b>{{longTermGapEmptyMultiplierPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapEmptyMultiplierPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #longTermGapEmptyMultiplierPCT (change)="onFieldValueChange('longTermGapEmptyMultiplierPCT', 'longTermGapEmptyMultiplierPCTExpDate')" formControlName="longTermGapEmptyMultiplierPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapEmptyMultiplierPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Long Term Gap Empty Multiplier PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="longTermGapEmptyMultiplierPCTExpDatePicker" formControlName="longTermGapEmptyMultiplierPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="longTermGapEmptyMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #longTermGapEmptyMultiplierPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.longTermGapEmptyMultiplierPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('longTermGapEmptyMultiplierPCTExpDate').hasError(validation.type) && (form1.get('longTermGapEmptyMultiplierPCTExpDate').dirty || form1.get('longTermGapEmptyMultiplierPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('longTermGapEmptyMultiplierPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('longTermGapEmptyMultiplierPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('longTermGapEmptyMultiplierPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('longTermGapEmptyMultiplierPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>Long Term Gap Empty Penalty PCT: <b>{{longTermGapEmptyPenaltyPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('longTermGapEmptyPenaltyPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #longTermGapEmptyPenaltyPCT (change)="onFieldValueChange('longTermGapEmptyPenaltyPCT', 'longTermGapEmptyPenaltyPCTExpDate')" formControlName="longTermGapEmptyPenaltyPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('longTermGapEmptyPenaltyPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Long Term Gap Empty Penalty PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="longTermGapEmptyPenaltyPCTExpDatePicker" formControlName="longTermGapEmptyPenaltyPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="longTermGapEmptyPenaltyPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #longTermGapEmptyPenaltyPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.longTermGapEmptyPenaltyPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('longTermGapEmptyPenaltyPCTExpDate').hasError(validation.type) && (form1.get('longTermGapEmptyPenaltyPCTExpDate').dirty || form1.get('longTermGapEmptyPenaltyPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('longTermGapEmptyPenaltyPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('longTermGapEmptyPenaltyPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('longTermGapEmptyPenaltyPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('longTermGapEmptyPenaltyPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>Connecting Front Or Back Multiplier PCT: <b>{{connectingFrontOrBackMultiplierPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('connectingFrontOrBackMultiplierPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #connectingFrontOrBackMultiplierPCT (change)="onFieldValueChange('connectingFrontOrBackMultiplierPCT', 'connectingFrontOrBackMultiplierPCTExpDate')" formControlName="connectingFrontOrBackMultiplierPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('connectingFrontOrBackMultiplierPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Connecting Front Or Back Multiplier PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="connectingFrontOrBackMultiplierPCTExpDatePicker" formControlName="connectingFrontOrBackMultiplierPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="connectingFrontOrBackMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #connectingFrontOrBackMultiplierPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.connectingFrontOrBackMultiplierPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('connectingFrontOrBackMultiplierPCTExpDate').hasError(validation.type) && (form1.get('connectingFrontOrBackMultiplierPCTExpDate').dirty || form1.get('connectingFrontOrBackMultiplierPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('connectingFrontOrBackMultiplierPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('connectingFrontOrBackMultiplierPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('connectingFrontOrBackMultiplierPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('connectingFrontOrBackMultiplierPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <div class="w-100">
            <mat-label>Connecting Front And Back Multiplier PCT: <b>{{connectingFrontAndBackMultiplierPCT.value*100}}%</b></mat-label>
            <div>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="decreasePercentage('connectingFrontAndBackMultiplierPCT')">
                <i class="pi pi-minus"></i>
              </button>
              <mat-slider class="flex-1" min="-1" max="1" step=".01"
                pTooltip="Range: -1 to +1 as decimal."
                tooltipPosition="bottom">
                <input matSliderThumb #connectingFrontAndBackMultiplierPCT (change)="onFieldValueChange('connectingFrontAndBackMultiplierPCT', 'connectingFrontAndBackMultiplierPCTExpDate')" formControlName="connectingFrontAndBackMultiplierPCT">
              </mat-slider>
              <button class="btn btn-icon btn-success rounded-pill mb-6" (click)="increasePercentage('connectingFrontAndBackMultiplierPCT')">
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Connecting Front And Back Multiplier PCT Exp Date</mat-label>
            <input matInput [matDatepicker]="connectingFrontAndBackMultiplierPCTExpDatePicker" formControlName="connectingFrontAndBackMultiplierPCTExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="connectingFrontAndBackMultiplierPCTExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #connectingFrontAndBackMultiplierPCTExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.connectingFrontAndBackMultiplierPCTExpDate; track validation) {
              <mat-error>
                @if (form1.get('connectingFrontAndBackMultiplierPCTExpDate').hasError(validation.type) && (form1.get('connectingFrontAndBackMultiplierPCTExpDate').dirty || form1.get('connectingFrontAndBackMultiplierPCTExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('connectingFrontAndBackMultiplierPCTExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('connectingFrontAndBackMultiplierPCTExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('connectingFrontAndBackMultiplierPCTExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('connectingFrontAndBackMultiplierPCTExpDate', 'N')">N</a>
          </mat-form-field>
        </div>

        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Length Of Stay Discount Factor Offset</mat-label>
            <input matInput (blur)="onFieldValueChange('lengthOfStayDiscountFactorOffset', 'lengthOfStayDiscountFactorOffsetExpDate')" formControlName="lengthOfStayDiscountFactorOffset">
            @for (validation of validationMessages.lengthOfStayDiscountFactorOffset; track validation) {
              <mat-error>
                @if (form1.get('lengthOfStayDiscountFactorOffset').hasError(validation.type) && (form1.get('lengthOfStayDiscountFactorOffset').dirty || form1.get('lengthOfStayDiscountFactorOffset').touched)) {
                  <mat-error class="error-message"
                    >
                    {{validation.message}}
                  </mat-error>
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-lg-6">
          <mat-form-field class="w-100">
            <mat-label>Length Of Stay Discount Factor Offset Exp Date</mat-label>
            <input matInput [matDatepicker]="lengthOfStayDiscountFactorOffsetExpDatePicker" formControlName="lengthOfStayDiscountFactorOffsetExpDate">
            <mat-datepicker-toggle matIconSuffix [for]="lengthOfStayDiscountFactorOffsetExpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #lengthOfStayDiscountFactorOffsetExpDatePicker></mat-datepicker>
            @for (validation of validationMessages.lengthOfStayDiscountFactorOffsetExpDate; track validation) {
              <mat-error>
                @if (form1.get('lengthOfStayDiscountFactorOffsetExpDate').hasError(validation.type) && (form1.get('lengthOfStayDiscountFactorOffsetExpDate').dirty || form1.get('lengthOfStayDiscountFactorOffsetExpDate').touched)) {
                  <mat-error class="error-message">
                  {{validation.message}}</mat-error>
                }
              </mat-error>
            }
            <a (click)="updateExpDate('lengthOfStayDiscountFactorOffsetExpDate', 7)">7</a>&nbsp;
            <a (click)="updateExpDate('lengthOfStayDiscountFactorOffsetExpDate', 14)">14</a>&nbsp;
            <a (click)="updateExpDate('lengthOfStayDiscountFactorOffsetExpDate', 21)">21</a>&nbsp;
            <a (click)="updateExpDate('lengthOfStayDiscountFactorOffsetExpDate', 'N')">N</a>
          </mat-form-field>
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (rateId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!rateId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (rateId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
